import { render, staticRenderFns } from "./ProductsVariants.vue?vue&type=template&id=48753505&"
import script from "./ProductsVariants.vue?vue&type=script&lang=js&"
export * from "./ProductsVariants.vue?vue&type=script&lang=js&"
import style0 from "./ProductsVariants.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports